/**
 * @generated SignedSource<<fdc9409433c5e6476c3ce62479093916>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      }
    ],
    "concreteType": "AccountSpending",
    "kind": "LinkedField",
    "name": "getaccountspendingthismonth2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spentThisMonth",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSpendingThisMonthFetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountSpendingThisMonthFetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ae06c144d7ab5561fa7bcdd495c90f0c",
    "id": null,
    "metadata": {},
    "name": "AccountSpendingThisMonthFetchQuery",
    "operationKind": "query",
    "text": "query AccountSpendingThisMonthFetchQuery(\n  $accountId: UUID!\n) {\n  getaccountspendingthismonth2(accountid: $accountId) {\n    spentThisMonth\n    budget\n  }\n}\n"
  }
};
})();

node.hash = "4548b3807a60e1befdf8281eab25e13f";

module.exports = node;
